import React from 'react'

const DATE_TEXT_LENGTH = 10
const TIME_TEXT_START_INDEX = 11
const DATE_TIME_TEXT_LENGTH = 19

const formatLocalDate = (date) => {
    const year = date.getFullYear()
    const month = (`0${date.getMonth() + 1}`).slice(-2)
    const day = (`0${date.getDate()}`).slice(-2)

    return `${year}-${month}-${day}`
}

const formatLocalTime = (date) => {
    const hour = (`0${date.getHours()}`).slice(-2)
    const minute = (`0${date.getMinutes()}`).slice(-2)
    const second = (`0${date.getSeconds()}`).slice(-2)

    return `${hour}:${minute}:${second}`
}

// 날짜 문자열만 필요한 영역에서 비어 있거나 짧은 값은 '-'로 표시한다.
export const formatDate = (value, {
    emptyFallback = '-',
    invalidFallback = emptyFallback,
    parseString = false,
} = {}) => {
    if (value === null || value === undefined || value === '') {
        return emptyFallback
    }

    if (value instanceof Date || parseString) {
        const nextDate = new Date(value)

        return Number.isNaN(nextDate.getTime()) ? invalidFallback : formatLocalDate(nextDate)
    }

    const dateText = String(value).slice(0, DATE_TEXT_LENGTH)

    return dateText || invalidFallback
}

// 기존 JSX 사용처 호환을 위해 날짜 문자열 포맷 함수를 renderDate 이름으로도 제공한다.
export const renderDate = formatDate

// 날짜/시간 문자열에서 시간 영역만 분리한다. 기본값은 기존 공지 목록처럼 완전한 시간만 표시한다.
export const formatTimeText = (value, {
    emptyFallback = '',
    invalidFallback = emptyFallback,
    requireFullTime = true,
} = {}) => {
    if (value === null || value === undefined || value === '') {
        return emptyFallback
    }

    const textValue = String(value)

    if (requireFullTime && textValue.length < DATE_TIME_TEXT_LENGTH) {
        return invalidFallback
    }

    return textValue.slice(TIME_TEXT_START_INDEX, DATE_TIME_TEXT_LENGTH) || invalidFallback
}

// 한 줄 날짜/시간 텍스트가 필요한 영역에서 기존 19자리 표시 형식을 안전하게 유지한다.
export const formatDateTimeText = (value, fallback = '-') => {
    if (value === null || value === undefined || value === '') {
        return fallback
    }

    return String(value).slice(0, DATE_TIME_TEXT_LENGTH) || fallback
}

// Date로 해석 가능한 값을 관리자 로컬 시간대의 yyyy-MM-dd HH:mm:ss 형식으로 표시한다.
export const formatLocalDateTime = (value, fallback = '-') => {
    if (value === null || value === undefined || value === '') {
        return fallback
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? fallback : `${formatLocalDate(nextDate)} ${formatLocalTime(nextDate)}`
}

// 상세 화면에서 브라우저 locale 기반 날짜/시간을 그대로 보여줘야 할 때 사용한다.
export const formatLocaleDateTime = (value, fallback = '-') => {
    if (value === null || value === undefined || value === '') {
        return fallback
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? fallback : nextDate.toLocaleString('ko-KR')
}

// 기간 컬럼에서 시작일과 종료일을 기존 줄바꿈 형식으로 표시한다.
export const renderDateRange = (startValue, endValue) => {
    const startDate = formatDate(startValue)
    const endDate = formatDate(endValue)

    if (startDate === '-' && endDate === '-') {
        return '-'
    }

    return (
        <React.Fragment>
            {startDate} ~
            <br />
            {endDate}
        </React.Fragment>
    )
}

// 목록 날짜 값이 비어 있거나 짧아도 렌더링이 깨지지 않도록 안전한 표시값을 만든다.
export const renderDateTime = (value) => {
    if (!value) {
        return '-'
    }

    const textValue = String(value)
    const dateText = textValue.slice(0, DATE_TEXT_LENGTH)
    const timeText = formatTimeText(textValue, { requireFullTime: false })

    if (!dateText) {
        return '-'
    }

    return (
        <React.Fragment>
            {dateText}
            {timeText && (
                <React.Fragment>
                    <br />
                    {timeText}
                </React.Fragment>
            )}
        </React.Fragment>
    )
}
